import React, { useState, useEffect } from "react";
import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import { NavLink, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context";
import useFetchObjects from "../../../api/useFetchObjects";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
  transition: "all 0.3s ease",
};

const highlightTabStyle = {
  backgroundColor: "#FFEBEE",
  color: "#D32F2F",
  fontWeight: "bold",
  borderRadius: "10px",
};

const ReceptionNav = () => {
  const { t } = useTranslation();
  const auth = useAuth();
  const token = auth?.user?.token;
  const [value, setValue] = useState("/reception");
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  useEffect(() => {
    const path = location.pathname;
    setValue(path);
  }, [location.pathname]);

  const isAdmin = auth?.user?.user?.isAdmin;
  const loginPerms = auth?.user?.user?.permissions || {};

  const userId = auth?.user?.user?.id;
  const { data: freshUserData } = useFetchObjects(
    ["reception-nav-perms", userId],
    userId ? `users/${userId}/` : "",
    token,
    { enabled: !!userId && !!token }
  );

  const perms = freshUserData ? {
    reception_dashboard: freshUserData.reception_dashboard || false,
    reception_new_patient: freshUserData.reception_new_patient || false,
    reception_patient_list: freshUserData.reception_patient_list || false,
    reception_patient_referral: freshUserData.reception_patient_referral || false,
    reception_opd: freshUserData.reception_opd || false,
    reception_ticketing: freshUserData.reception_ticketing || false,
    reception_return_medicine: freshUserData.reception_return_medicine || false,
  } : loginPerms;

  const allTabs = [
    { path: "/reception",                          label: t("reception.dashboard") || "Dashboard", permKey: "reception_dashboard" },
    { path: "/reception/new-patient",              label: t("reception.newPatient"),                         permKey: "reception_new_patient" },
    { path: "/reception/patient-list",             label: t("reception.patientList"),                        permKey: "reception_patient_list" },
    { path: "/reception/patient-referral",         label: t("reception.patientReferral") || "Patient Referral", permKey: "reception_patient_referral" },
    { path: "/reception/appointments",             label: t("reception.OPD"),                                permKey: "reception_opd" },
    { path: "/reception/ticketing",                label: "Ticketing",                                       permKey: "reception_ticketing" },
    { path: "/reception/return-medicine",          label: t("reception.returnMedicine") || "Return Medicine", permKey: "reception_return_medicine" },
  ];

  const tabs = allTabs.filter(({ permKey }) => isAdmin || perms[permKey]);

  return (
    <Grid container>
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={(e, newValue) => {
              setValue(newValue);
              navigate(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{ ml: "5px", "& .MuiTabs-indicator": { display: "none" } }}
          >
            {tabs.map(({ path, label }) => (
              <Tab
                key={path}
                sx={{ mr: 2 }}
                style={{
                  ...tabStyle,
                  backgroundColor:
                    value === path ? theme?.palette.primary.main : "white",
                  color: value === path ? "white" : "black",
                }}
                label={label}
                value={path}
                component={NavLink}
                to={path}
              />
            ))}
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default ReceptionNav;
